import React from 'react'
import IntlMessages from "../../../helpers/IntlMessages";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const ConfirmDialog = (props) => {
    const { modal, toggleModal, submitForm } = props;
    return (
        <Modal isOpen={modal} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal}>
                <IntlMessages id="menu.reportProblem" />
            </ModalHeader>
            <ModalBody>
                <IntlMessages id="menu.sendReportConfirmMessage" />
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggleModal}>
                    <IntlMessages id="user.cancel" />
                </Button>
                <Button color="primary" onClick={submitForm}>
                    <IntlMessages id="menu.sendReport" />
                </Button>
            </ModalFooter>
        </Modal>
    )
};

export default ConfirmDialog;
